import { LineItemForm } from "@/schema/schema";

export const lineItemDefaultValue: LineItemForm = {
  classification: "",
  description: "",
  unitPrice: 0,
  taxType: "06" as const,
  codeNumber: "NA",
  taxRate: 0,
  taxAmount: 0,
  detailsOfTaxExemption: "NA",
  amountExemptedFromTax: 0,
  subtotal: 0,
  totalExcludingTax: 0,
  quantity: 1,
  measurement: "NA",
  discountRate: 0,
  discountAmount: 0,
  feeRate: 0,
  feeAmount: 0,
  productTariffCode: "NA",
  countryOfOrigin: "MYS",
  total: 0,
};
